// extracted by mini-css-extract-plugin
export default {"container":"PageNotAccsess_container__VK8Eg"};